import React from "react";

import Text from "../Typography/Text";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./ColorDotWithLabel.module.css";

interface Props {
  color: string;
  label: string;
  className?: string;
}

const ColorDotWithLabel: React.FC<Props> = ({ color, label, className }) => {
  return (
    <div className={toClassName(styles.container, className)}>
      <div
        className={styles.colorDot}
        style={{
          backgroundColor: color,
        }}
      />

      <Text variant={"body"} color={"text"}>
        {label}
      </Text>
    </div>
  );
};

export default ColorDotWithLabel;
